require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-succeed-with-saving-in-2018.json") })
        }
      }, "path---es-articles-succeed-with-saving-in-2018");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-succeed-with-saving-in-2018!./.cache/json/es-articles-succeed-with-saving-in-2018.json
// module id = 2248
// module chunks = 231608221292675